// The max number of events to fetch each time from DAL
export const MAX_EVENTS_TO_FETCH = 50;

// The below three constants are used for making the keys unique for header, and events
export const SUFFIX_AGENDA_SEPARATOR = '_separator';
export const SUFFIX_AGENGA_EVENT = '_event';

// Step count of days to fetch
export const DAYS_TO_FETCH = 25;

export const DAYS_TO_FETCH_FOR_PIVOT = 20;

export const DAYS_TO_LOOKAHEAD_FOR_UPNEXT: number = 1;
